/* Paola Milano — boutique redesign: gentle reveal-on-scroll for [data-pmb-reveal] elements.
   Content stays visible without JS; the hidden state is only added here. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = document.querySelectorAll('[data-pmb-reveal]');
  if (!items.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  items.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight) return; // already on screen: leave as is
    el.classList.add('pmb-reveal');
    io.observe(el);
  });
})();
